<template>
  <CContainer :fluid="true">
    <CRow>
      <!-- MODALS -->
      <CModal
        id="room-capacity-limit-modal"
        ref="roomCapacityModalRef"
        backdrop="static"
        :visible="state.modal.isVisible"
        :close-on-backdrop="false"
      >
        <div
          class="pt-4 px-4 create-popup-header d-flex align-items-center justify-content-between"
        >
          <HelpCenterButton
            content-key="limit_location_max_cap"
            :is-old="true"
          />
          <div class="text-end close-btn">
            <button
              type="button"
              class="close-modal-action btn btn-link p-0 border-0"
              aria-label="Close room capacity modal"
              @click="closeModal()"
            >
              <i class="ri-close-line cursor-pointer" aria-hidden="true" />
            </button>
          </div>
        </div>
        <div v-if="state.activeRoom" class="px-3">
          <h2 class="mb-4 text-center">Limit Location Max Cap</h2>
          <CreateLimitLocationMaxCapForm
            :is-in-view="false"
            :is-dashboard-view="true"
            :active-room="
              state.activeRoom.room_advance
                ? state.activeRoom.room_advance
                : state.activeRoom
            "
            :editable-limit-data="
              state.activeRoom.room_advance
                ? state.activeRoom.room_advance
                : state.activeRoom
            "
            @updated-limit-location-max-cap="state.modal.isVisible = false"
            @close-modal="state.modal.isVisible = false"
          />
        </div>
        <template #footer-wrapper>
          <div></div>
        </template>
      </CModal>
      <CCol
        v-if="autoPassesRooms && autoPassesRooms.length"
        md="12"
        class="bg-white d-flex justify-content-center flex-wrap"
      >
        <div
          id="dashboard-room-capacities-panel"
          :class="state.hideRoomCapacities ? 'd-none' : 'd-flex'"
          class="rooms-stats-container align-items-center px-4"
          role="region"
          aria-labelledby="dashboard-room-capacities-title"
        >
          <h2
            id="dashboard-room-capacities-title"
            class="me-4 mb-0 stats-title"
          >
            Room Capacities:
          </h2>
          <div class="rooms-stats">
            <button
              v-for="(room, index) in autoPassesRooms"
              :key="index"
              type="button"
              class="stat cursor-pointer border-0"
              :aria-label="`${room.room.name} capacity ${room.limit !== null ? room.limit : 'not set'}`"
              @click="showModal(room)"
            >
              {{ room.room.name }}
              <span>
                {{ room.limit !== null ? room.limit : "-" }}
              </span>
            </button>
          </div>
        </div>
        <button
          type="button"
          class="text-text-color-dark p-2 w-full text-center cursor-pointer border-0 bg-transparent w-100 room-capacities-toggle-btn"
          :aria-expanded="state.hideRoomCapacities ? 'false' : 'true'"
          aria-controls="dashboard-room-capacities-panel"
          :aria-label="
            state.hideRoomCapacities
              ? 'Expand room capacities'
              : 'Collapse room capacities'
          "
          @click="state.hideRoomCapacities = !state.hideRoomCapacities"
        >
          <div
            v-if="state.hideRoomCapacities"
            class="d-flex align-items-center justify-content-center toggler-btn"
          >
            <span class="stats-title">Room Capacities</span>
            <span class="flaticon-down-arrow ms-1" aria-hidden="true"></span>
          </div>
          <div v-else class="d-flex align-items-center justify-content-center">
            <span class="flaticon-up-arrow ms-1" aria-hidden="true"></span>
          </div>
        </button>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import { reactive, computed, ref } from "vue"
import { useStore } from "vuex"
import CreateLimitLocationMaxCapForm from "@/v3components/Forms/CreateLimitLocationMaxCapForm.vue"
import HelpCenterButton from "@/v3components/HelpCenterButton.vue"
import useLegacyModalFocusTrap from "@/composables/useLegacyModalFocusTrap"

export default {
  name: "RoomStatsOld",
  components: {
    CreateLimitLocationMaxCapForm,
    HelpCenterButton
  },
  setup() {
    const store = useStore()
    const roomCapacityModalRef = ref(null)

    const state = reactive({
      modal: {
        isVisible: false
      },
      activeRoom: null,
      hideRoomCapacities: true
    })

    const autoPassesRooms = computed(() => {
      return store.getters["dashboardTable/staffSchedules"]
    })

    const showModal = (room) => {
      state.activeRoom = room
      state.modal.isVisible = true
    }

    const closeModal = () => {
      state.modal.isVisible = false
      state.activeRoom = null
    }

    useLegacyModalFocusTrap(
      "room-capacity-limit-modal",
      computed(() => state.modal.isVisible),
      closeModal,
      () => {
        const refElement = roomCapacityModalRef.value?.$el
        if (!refElement) return null
        if (refElement.classList?.contains("modal")) return refElement
        return refElement.querySelector?.(".modal")
      }
    )

    return {
      state,
      roomCapacityModalRef,
      autoPassesRooms,
      showModal,
      closeModal
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/_variables.scss";

.rooms-stats .stat:focus-visible,
.create-popup-header > button:focus-visible {
  outline: 2px solid $outline-color !important;
  outline-offset: $outline-offset !important;
}

.rooms-stats .stat:focus-visible,
.room-capacities-toggle-btn:focus-visible {
  outline: 2px solid $outline-color !important;

  .stats-title {
    outline: 2px solid $outline-color !important;
    outline-offset: $outline-offset !important;
  }
}
</style>
